import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "frodrigo_cookie_consent_v1";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            const v = localStorage.getItem(KEY);
            if (!v) {
                const t = setTimeout(() => setVisible(true), 700);
                return () => clearTimeout(t);
            }
        } catch (e) {
            setVisible(true);
        }
    }, []);

    const accept = () => {
        try { localStorage.setItem(KEY, "accepted"); } catch (e) {}
        setVisible(false);
    };
    const reject = () => {
        try { localStorage.setItem(KEY, "rejected"); } catch (e) {}
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-banner"
            className="fixed bottom-4 inset-x-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[60] animate-float"
            style={{ animation: "reveal 0.5s ease both" }}
        >
            <div className="relative bg-brand-navy text-brand-cream rounded-2xl shadow-2xl ring-1 ring-white/10 p-5 md:p-6">
                <button
                    onClick={reject}
                    aria-label="Cerrar"
                    data-testid="cookie-close"
                    className="absolute top-3 right-3 p-1.5 rounded-lg text-brand-cream/60 hover:text-white hover:bg-white/10"
                >
                    <X className="h-4 w-4" />
                </button>
                <div className="flex items-start gap-3">
                    <div className="h-9 w-9 shrink-0 rounded-lg bg-brand-red/15 ring-1 ring-brand-red/30 grid place-items-center">
                        <Cookie className="h-4 w-4 text-brand-red" />
                    </div>
                    <div>
                        <h4 className="font-display font-semibold text-[15px]">Uso de cookies</h4>
                        <p className="mt-1.5 text-[13px] leading-relaxed text-brand-cream/75">
                            Este sitio utiliza únicamente cookies técnicas necesarias para su funcionamiento. No empleamos cookies de análisis ni de publicidad. Consulta nuestra{" "}
                            <Link
                                to="/politica-cookies"
                                className="underline underline-offset-2 text-white hover:text-brand-red"
                            >
                                Política de cookies
                            </Link>
                            .
                        </p>
                        <div className="mt-4 flex items-center gap-2">
                            <button
                                data-testid="cookie-accept"
                                onClick={accept}
                                className="pill bg-brand-red hover:bg-brand-red-600 text-white px-4 py-2 text-[13px] font-semibold transition-colors"
                            >
                                Aceptar
                            </button>
                            <button
                                data-testid="cookie-reject"
                                onClick={reject}
                                className="pill bg-white/10 hover:bg-white/15 text-white px-4 py-2 text-[13px] font-semibold transition-colors"
                            >
                                Rechazar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
